import React, { type FC } from 'react';
import { connect } from 'react-redux';
import { useSpotlightDisplay } from '../../hooks/use-spotlight-display';
import { SemanticTopBar } from '../SemanticSearch/components/SemanticTopBar';

interface TopBarProps {
	categoryCode: Category.CategoryCode;
	location: Redux.Location;
	marketCode: string;
}

const TopBar: FC<TopBarProps> = (props) => {
	const { categoryCode, marketCode } = props;
	const { shouldShowSpotlight, isCurrentBowFilterApplied } =
		useSpotlightDisplay();

	return (
		<SemanticTopBar
			categoryCode={categoryCode}
			isBOW={isCurrentBowFilterApplied}
			location={props.location}
			marketCode={marketCode}
			shouldShowSpotlight={shouldShowSpotlight}
		/>
	);
};

const mapStateToProps = (state: Redux.State) => ({
	categoryCode: state.category.code,
	location: state.location,
	marketCode: state.settings.marketCode,
});

export default connect(mapStateToProps)(TopBar);
